import React, { useEffect } from 'react';
import { Title, Meta, Link } from 'react-head';
import { motion } from 'framer-motion';
import TripleTrustHero from '../../sections/HeroSection/TripleTrustHero';
import ServicesSlider from '../../sections/ServicesSlider/ServicesSlider';
import TrinityServicesSection from '../../sections/servicesection/TrinityServicesSection';
import AboutUs from '../../sections/AboutUs/AboutUs';
import KeyStats from '../../sections/KeyStats/KeyStats';
import ContactSection from '../../sections/contact/ContactSection';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '$1M-$500B Project Financing & Trade Finance | Trinity Financing Agent';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', 'Global financial agency Services | Experts in project financing, equity partnerships, business capital, trade finance, bank instruments, and surety bonds.');
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) metaKeywords.setAttribute('content', 'Trinity Financing, international project financing, global financial brokers, project finance companies, international funding companies, project financing, large project financing, project finance funding, project finance experts, project finance international, structured project finance, infrastructure development finance, PPP project finance, project finance modelling, project finance accounting, joint venture project finance, real estate project finance, real estate development financing, property financing, commercial property lender, financing property development, apartment construction financing, real estate construction financing, real estate development funding, commercial building financing, hotel construction lenders, trade finance, trade financing, trade finance instruments, invoice financing, invoice funding, invoice discounting, factoring finance, PO financing, working capital, project investors, investors for real estate, construction investors, international angel investors, venture capital funds, venture capital firm, Chinese investors, Japan investors, Saudi investors list, development finance lenders, development finance institutions, commercial development finance, joint venture development finance, funding for African projects, European funding, international funding, green energy finance, renewable energy projects, solar project financing, agriculture funding, farmland financing, equipment financing, equipment leasing, machinery funding, restaurant financing, franchise financing, construction financing, construction financing companies, contractor financing, building finance, construction funds, funding for construction projects, funding for construction companies, corporate finance, business capital, company funding, corporate funding, acquisition financing, acquisition finance, debt financing, equity financing, blended financing, alternative financing, project financing in Kenya, joint venture companies in Kenya, property financing in Kenya, international funders in South Africa, investors in Namibia, international lenders in USA, venture capital, development finance, commercial property financing');
  }, []);

  return (
    <>
      {/* SEO Meta Tags */}
      <Title>$1M-$500B Project Financing & Trade Finance | Trinity Financing Agent</Title>
      
      <Meta name="description" content="Global financial agency Services | Experts in project funding, equity partnerships, business capital, trade finance, bank instruments, and surety bonds." />
      
      <Meta name="keywords" content="Trinity Financing, Global financial agency Services, international project financing, global financial brokers, project finance companies, international funding companies, project financing, large project financing, project finance funding, project finance experts, project finance international, structured project finance, infrastructure development finance, PPP project finance, project finance modelling, project finance accounting, joint venture project finance, real estate project finance, real estate development financing, property financing, commercial property lender, financing property development, apartment construction financing, real estate construction financing, real estate development funding, commercial building financing, hotel construction lenders, trade finance, trade financing, trade finance instruments, invoice financing, invoice funding, invoice discounting, factoring finance, PO financing, working capital, project investors, investors for real estate, construction investors, international angel investors, venture capital funds, venture capital firm, Chinese investors, Japan investors, Saudi investors list, development finance lenders, development finance institutions, commercial development finance, joint venture development finance, funding for African projects, European funding, international funding, green energy finance, renewable energy projects, solar project financing, agriculture funding, farmland financing, equipment financing, equipment leasing, machinery funding, restaurant financing, franchise financing, construction financing, construction financing companies, contractor financing, building finance, construction funds, funding for construction projects, funding for construction companies, corporate finance, business capital, company funding, corporate funding, acquisition financing, acquisition finance, debt financing, equity financing, blended financing, alternative financing, project financing in Kenya, joint venture companies in Kenya, property financing in Kenya, international funders in South Africa, investors in Namibia, international lenders in USA, venture capital, development finance, commercial property financing" />
      
      <Meta name="robots" content="index, follow" />
      <Meta name="author" content="Trinity Financing" />
      
      <Link rel="canonical" href="https://trinityfinancing.com/" />
      
      {/* Open Graph Tags */}
      <Meta property="og:type" content="website" />
      <Meta property="og:url" content="https://trinityfinancing.com/" />
      <Meta property="og:title" content="Global Financial Sourcing | Funding, Equity, Trade Finance & Bonds" />
      <Meta property="og:description" content="Global Financial Sourcing Brokers | Experts in project funding, equity partnerships, business capital, trade finance, bank instruments, and surety bonds." />
      <Meta property="og:image" content="https://trinityfinancing.com/micro-finance.jpg" />
      <Meta property="og:image:width" content="1200" />
      <Meta property="og:image:height" content="630" />
      <Meta property="og:site_name" content="Trinity Financing" />
      <Meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Tags */}
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content="Global Financial Sourcing | Funding, Equity, Trade Finance & Bonds" />
      <Meta name="twitter:description" content="Global Financial Sourcing Brokers | Experts in project funding, equity partnerships, business capital, trade finance, bank instruments, and surety bonds." />
      <Meta name="twitter:image" content="https://trinityfinancing.com/micro-finance.jpg" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FinancialService",
          "name": "Trinity Financing Agent",
          "description": "Global financial agency & trade finance solutions providers. Experts in project funding, equity partnerships, business capital, trade finance, bank instruments, and surety bonds.",
          "url": "https://trinityfinancing.com",
          "logo": "https://trinityfinancing.com/logo.png",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Ground flr, Bldg 4, 50 Constantia Blvd, Constantia Kloof",
            "addressLocality": "Johannesburg",
            "postalCode": "1709",
            "addressCountry": "ZA"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "-26.1314",
            "longitude": "27.9328"
          },
          "email": "finance.support@trinityfinancing.com",
          "areaServed": {
            "@type": "Country",
            "name": "Worldwide"
          },
          "slogan": "Your Pathway to $1M-$500B Project Funding",
          "foundingDate": "2009",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "500"
          }
        })}
      </script>

      {/* Page Content */}
      <main className="main-content">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="section-container"
        >
          <TripleTrustHero />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="section-container"
        >
          <ServicesSlider />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="section-container"
        >
          <TrinityServicesSection />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="section-container"
        >
          <AboutUs />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="section-container"
        >
          <KeyStats />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="section-container"
        >
          <ContactSection />
        </motion.div>
      </main>
    </>
  );
};

export default Home;